<template>
  <div id="app">
    <!-- 全局头部 - 根据路由 meta 决定是否显示 -->
    <Header v-if="!$route.meta.hideHeader" />
    
    <!-- 主要内容区域 -->
    <main class="main-content" :class="{ 'no-header': $route.meta.hideHeader }">
      <router-view></router-view>
    </main>
  </div>
</template>

<script setup>
import Header from '#/components/Header/index.vue'
</script>

<style lang="scss" scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 124px; // 为固定头部留出空间

  &.no-header {
    padding-top: 0; // 没有头部时不需要 padding
  }
}

// 响应式调整
@media (max-width: 768px) {
  .main-content {
    padding-top: 56px;

    &.no-header {
      padding-top: 0;
    }
  }
}

@media (max-width: 480px) {
  .main-content {
    padding-top: 52px;

    &.no-header {
      padding-top: 0;
    }
  }
}
</style>